import React from 'react';
import Button from '../button';
import './stylesheet/intro.css';
const tags=["English","Hindi","India","Freelancer"];


const Intro = () => {
  return (
    <>
    
    <div className="main-component">
    <div className="img "></div>
    <div className="text">
      <h1 >Hii, My Name is </h1>
      <span>Umang sahu</span>
      <small>web developer || frontend developer </small>
      <p className='content'>I am an electrical engineer turned into a front-end developer. currently, I am in my final year at BIET Jhansi. I've good experience in coding and excellent experience in a language like Html, Css Javascript, and Libary like React. <br></br>
during these Days I was worked on many side projects (to see my projects click here) </p>

<div className="tag">
  

{
  tags.map((currelem)=>{
    return(
  
        <p>{currelem}</p>
    
    )
  })
}
</div>
    </div>
   
    </div>
    <div className="button-section">
      <Button title={"Resume"} subtext={"Download My"}/>
    </div>
    </>
  )
}

export default Intro